import {
    UPDATE_APP_TYPE, SET_ACCESS_FIELD, SET_DEAL_ROOM_ID, SET_FIELD_DATA,
    SET_AUTHTOKEN, SET_DEALROOM_DATA
} from "../../constants/ActionTypes";

const initialState = {
    applicationType: null,
    dealRoomId: null,
    accessField: 'email',
    emailFieldData: 0,
    dealRoomData: null,
    authToken: null
};

const headerReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case UPDATE_APP_TYPE:
            return { ...state, logout: payload };
        case SET_DEAL_ROOM_ID:
            return { ...state, dealRoomId: payload };
        case SET_ACCESS_FIELD:
            return { ...state, accessField: payload };
        case SET_FIELD_DATA:
            return { ...state, emailFieldData: payload };
        case SET_DEALROOM_DATA:
            return { ...state, dealRoomData: payload };
        case SET_AUTHTOKEN:
            return { ...state, authToken: payload };
        default:
            return state;
    }
};
export default headerReducer;
